const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 213.312,
    x2: 213.312,
    y1: 8.348,
    y2: 504.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FF1B2D"
    },
    stopColor: "#ff1b2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    style: {
      stopColor: "#FA1A2C"
    },
    stopColor: "#fa1a2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopColor: "#ED1528"
    },
    stopColor: "#ed1528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    style: {
      stopColor: "#D60E21"
    },
    stopColor: "#d60e21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    style: {
      stopColor: "#B70519"
    },
    stopColor: "#b70519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A70014"
    },
    stopColor: "#a70014"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.737 400.271c-28.302-33.411-46.637-82.808-47.882-138.238-.004-.143-.004-11.918 0-12.061 1.245-55.429 19.579-104.825 47.88-138.235 36.728-47.692 91.843-66.439 152.807-66.439 37.504 0 102.081 19.869 102.081 19.869C381.558 24.848 322.138.253 256.968.012c-.323-.001-.644-.012-.967-.012-141.385 0-256 114.615-256 256.001 0 137.295 108.085 249.338 243.808 255.704 4.042.19 8.104.297 12.192.297 65.542 0 125.317-24.642 170.604-65.151 0 0-62.116 14.14-99.614 14.14-60.965-.001-118.528-13.03-155.254-60.72z",
    style: {
      fill: "url(#a)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 341.868,
    x2: 341.868,
    y1: 37.594,
    y2: 476.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C0000"
    },
    stopColor: "#9c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FF4B4B"
    },
    stopColor: "#ff4b4b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.735 111.737c23.489-27.729 53.836-44.453 86.982-44.453 74.523 0 134.936 84.493 134.936 188.719S333.24 444.721 258.717 444.721c-33.145 0-63.492-16.724-86.98-44.451 36.726 47.69 91.319 77.93 152.283 77.93 37.498 0 72.581-11.448 102.585-31.351 52.404-46.876 85.396-115.005 85.396-190.849 0-75.836-32.984-143.958-85.378-190.834-30.008-19.91-65.099-31.362-102.603-31.362-60.964.001-115.558 30.242-152.285 77.933z",
    style: {
      fill: "url(#b)"
    },
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/opera.656afe77b435d501ea92be350c9466d8.svg";
export { ForwardRef as ReactComponent };